import {IntermediatePart} from "../../intermediatePart";
import {METADATA, LOOK_ROOM_TYPES, ShowerHeadTypes, createParentPositions, ShowerComboTubType} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getCurrentRoomType} from "../../../../appLayout";
import {IS_LIXIL_SERVERS} from "../../../../../config";
// import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";
// import store from "../../../../../store";

export default class ShowerFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_fixture';
    this.partName = 'Fixture';
    this.translateId = "visualizer.bathroom.shower.shower_fixture";
    this.dbName = 'Shower Fixture';
    this.layerPriority = 4;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"] || (Array.isArray(dbFeature.metaData["Side"]) && dbFeature.metaData["Side"][0] === "0")) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    if (dbFeature.isFromAsRoom) {
      // Eugene Balan: добавил для Shower Fixture в метадату MountType значения для бандлов
      // S - прячем эти группы Shower Arm, Shower Head (т.к. они уже включены в набор)
      // T - показываем только если включен Replacement Tub + тоже что и S + прячем Tub Spout
      // 0 - можем показывать группы Shower Arm, Shower Head, Tub Spout (если включен Replacement Tub)
      // 0 - Hand Shower Kit должен показываться вместе с shower fixture у которых MountType: 0
      // if (Array.isArray(dbFeature.metaData["MountType"]) && !dbFeature.metaData["MountType"].includes("T")) {
      //   dbFeature.metaData["MountType"].push(METADATA.ALL)
      // }
      if (!Array.isArray(dbFeature.metaData["MountType"])) {
        console.log("alarm, alarm , this shower fixture has no MountType metadata!", dbFeature);
      }
      if (Array.isArray(dbFeature.metaData["ShowerSize"]) && dbFeature.metaData["ShowerSize"].includes("0")) {
        dbFeature.metaData["ShowerSize"] = [METADATA.ALL];
      }
    }
    return super.load(dbFeature)
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_fixture);
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      if (Array.isArray(this.metaData["MountType"]) && this.metaData["MountType"].includes("S")
        && ((showerParent.shower_head_type === ShowerHeadTypes.shower_arm && showerParent.showerArm && !showerParent.showerArm.disabled)
          || (showerParent.shower_head_type === ShowerHeadTypes.shower_head_bundle && showerParent.showerHeadBundle && !showerParent.showerHeadBundle.disabled))) {
        // store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
        // return;
        this.applyFeatureIfNotCompatible();
      }
    }
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    const showerTubComboParent = showerParent.layout.parts["Shower Tub Combo"];
    if (showerTubComboParent && showerTubComboParent.showerTubComboIsActive
      && showerTubComboParent.bottomTub !== "walk_in_tub" && !IS_LIXIL_SERVERS) { // they don't have repl tub fixture
      return true
    }
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_fixture && this.activeFeature
  }

  applyFeatureIfNotCompatible() {
    const showerParent = this.getParent().getParent();
    if (showerParent.showerArm) {
      showerParent.showerArm.disabled = true;
    }
    if (showerParent.showerHead) {
      showerParent.showerHead.disabled = true;
    }
    if (showerParent.showerHeadBundle) {
      showerParent.showerHeadBundle.disabled = true;
    }
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    if (getCurrentRoomType(showerParent.layout) === LOOK_ROOM_TYPES.as) {
      const showerComboParent = showerParent.layout.parts[ShowerTubCombo.id];

      let conditions = super.getArrayOfConditions(); //roomLayout
      const showerSize = showerParent.showerSize();
      if (showerSize) {
        conditions.push({
          propName: "ShowerSize",
          propValue: showerSize
        })
      }
      conditions.push({
        propName: "MountType",
        propValue: (showerComboParent && showerParent.showerTubComboIsActive()
          && showerComboParent.bottomTub === ShowerComboTubType.replacement_tub) ? "T" : "S"
      })
      return conditions
    }
    return super.getArrayOfConditions()
  }
}
